module.exports = __webpack_public_path__ + "static/img/starter.d62760d2.svg";